import { Link, useParams } from 'react-router-dom';
import './FooterTagSection.css';

const relatedLinks = [
    {
        id: 1,
        url: "/venue-list/restaurants-bar",
        tag: "Restaurants in Middle Circle",
    }, {

        id: 2,
        // url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place",
    }, {

        id: 3,
        // url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants",
    },
    {
        id: 4,
        // url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants in Delhi NCR",
    }, {
        id: 5,
        url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants in New Delhi",
    }, {
        id: 6,
        url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants in Central Delhi",
    },
    {
        id: 7,
        // url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants in New Delhi",
    }, {
        id: 8,
        url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Connaught Place Restaurants in Central Delhi",
    }, {
        id: 9,
        url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Casual Dining in Connaught Place",
    }, {
        id: 10,
        url: "./connaught-place-restaurants-in-delhi-ncr",
        tag: "Bar in Connaught Place",

    }

];



export default function FooterTagSection() {
    const { city, area, clubname } = useParams();


    //   const newApi = new FormData();
    //   newApi.append("city", city);
    //   newApi.append("area", area);
    //   newApi.append("club", clubname);

    return (
        <>
            <div className='vcdp-FooterTagSection'>
                <div className='vcdp-FooterTagSection-container'>
                    <div className='vcdp-FooterTagSection-content-header'>
                        <h1>Related to {clubname}-{area}-{city} </h1>
                    </div>
                    <div className='vcdp-FooterTagSection-content'>
                        <p className="vcdp-FooterTagSection-content-text-tags">
                            {relatedLinks.map((item, index) => (
                                <span key={index}>
                                    <Link
                                        to={item.url}
                                        className={item?.url ? 'vcdp-tag-link-blue' : 'vcdp-tag-link'}
                                    >
                                        {item.tag}
                                    </Link>
                                    {index !== relatedLinks.length - 1 && ", "}
                                </span>
                            ))}
                        </p>
                    </div>
                </div>
            </div>

        </>
    )
}
